import {
  ERROR_PERMISSION,
  GET_ALL_PERMISSIONS,
  SET_LOADING_PERMISSION,
  SET_PERMISSION_CLEAR,
  SET_SELECTED_ORG,
  SET_SELECTED_ROLE,
  USER_INFO,
} from '../types';

const initialState = {
  selectedRole: null,
  selectedOrg: null,
  permissions: null,
  error: null,
  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING_PERMISSION:
      return {
        ...state,
        isLoading: true,
      };

    case GET_ALL_PERMISSIONS:
      return {
        ...state,
        isLoading: false,
        permissions: action.payload,
      };

    case ERROR_PERMISSION:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case USER_INFO:
      return {
        ...state,
        data: action.payload,
      };
    case SET_SELECTED_ROLE:
      return {
        ...state,
        isLoading: false,
        selectedRole: action.payload,
      };

    case SET_SELECTED_ORG:
      return {
        ...state,
        isLoading: false,
        selectedOrg: action.payload,
      };

    default:
      return state;
  }
};
